// Swedish message translations
export const messages = {
  // Common UI elements
  "Send": "Skicka",
  "Clear chat": "Rensa chatten",
  "Support": "Support",
  "Settings": "Inställningar",
  "Language": "Språk",
  "Theme": "Tema",
  "Font Size": "Teckenstorlek",
  "Select language": "Välj språk",
  
  // Chat interface
  "Type your message...": "Skriv ditt meddelande...",
  "Thinking...": "Tänker...",
  "Labor Law Expert": "Arbetsrättsexpert",
  "by MJ": "av MJ",
  "Leen": "Leen",
  
  // Frameworks
  "Automatic detection": "Automatisk identifiering",
  "Labor Law": "Arbetsrätt",
  "Saudization": "Saudisering",
  "Contracts": "Anställningsavtal",
  "Termination": "Uppsägning",
  "Wages & Benefits": "Löner och förmåner",
  "Leave Policies": "Ledighetspolicyer",
  "Workplace Safety": "Arbetssäkerhet",
  
  // Models
  "Claude by Anthropic": "Claude från Anthropic",
  "DeepSeek by Groq": "DeepSeek från Groq",
  "MJ Lab Mode": "MJ labbläge",
  
  // Messages
  "Language changed to {{locale}}": "Språket ändrat till {{locale}}",
  "Hello, I am {{name}}, an AI assistant made by MJ.": "Hej, jag är {{name}}, en AI-assistent skapad av MJ.",
  "I am expert in labor laws and regulations for Saudi Arabia.": "Jag är expert på arbetsrättsliga lagar och förordningar i Saudiarabien.",
  "Ask me a question, and I will gladly answer you.": "Ställ en fråga till mig, så svarar jag gärna.",
  "Do not share confidential data.": "Dela inte konfidentiell data.",
  "I am powered using": "Jag drivs av",
  
  // Disclaimer
  "Disclaimer: {{name}} is an experimental AI assistant designed to respond using data from Saudi labor laws and regulations, avoiding assumptions or inaccuracies. I am not responsible for its behavior or the correctness of its responses.": "**Ansvarsfriskrivning:** {{name}} är en experimentell AI-assistent designad för att svara med hjälp av data från saudiska arbetsrättsliga lagar och förordningar, utan antaganden eller felaktigheter. Jag ansvarar inte för dess beteende eller riktigheten i dess svar.",
  
  // Error messages
  "An error occurred": "Ett fel inträffade",
  "Failed to change language": "Kunde inte ändra språk",
  "Please try again": "Försök igen",
  "Connection lost": "Anslutningen förlorades",
  "Reconnecting...": "Återansluter...",
  "Nothing to clear": "Inget att rensa",
  "All messages cleared": "Alla meddelanden rensade",
  "All data cleared": "All data rensad",
  "Storage limit reached": "Lagringsgränsen har nåtts",
  "Some older messages were removed to save space.": "Vissa äldre meddelanden togs bort för att spara utrymme.",
  "Error": "Fel",
  
  // Tooltips
  "Increase font size": "Öka teckenstorlek",
  "Decrease font size": "Minska teckenstorlek",
  "Reset font size": "Återställ teckenstorlek",
  "Change theme": "Ändra tema",
  "Support the project": "Stöd projektet",
  
  // Character count
  "{{remainingChars}} character left": "{{remainingChars}} tecken kvar",
  "{{remainingChars}} characters left": "{{remainingChars}} tecken kvar",
  
  // Message actions
  "Message copied to clipboard": "Meddelandet kopierat till urklipp",
  "Read": "Läs",
  "Summarize": "Sammanfatta",
  
  // Ice Breakers Dialog
  "Message Suggestions": "Meddelandeförslag",
  "Select a question to quickly start a conversation about Saudi labor laws.": "Välj en fråga för att snabbt starta en konversation om saudiska arbetsrättsliga lagar.",
  "What are the key employee rights under Saudi labor law? Can you provide a simple overview?": "Vilka är de viktigaste arbetstagarrättigheterna enligt saudisk arbetsrätt? Kan du ge en enkel översikt?",
  "What are the employer's obligations regarding work hours, overtime, and leave in Saudi Arabia?": "Vilka är arbetsgivarens skyldigheter gällande arbetstider, övertid och ledighet i Saudiarabien?",
  "How does Saudi labor law handle termination of employment and end-of-service benefits?": "Hur hanterar saudisk arbetsrätt uppsägning av anställning och slutersättning?",
  
  // Audio Player Dialog
  "AI Summary": "AI-sammanfattning",
  "Listen to the summarized response using our AI Service.": "Lyssna på det sammanfattade svaret med vår AI-tjänst.",
  "Generating summary...": "Genererar sammanfattning...",
  "Preparing audio...": "Förbereder ljud...",
  
  // Audio Player Error Messages
  "Failed to process text. Please try again.": "Kunde inte bearbeta texten. Försök igen.",
  "Failed to auto-play audio. Click play to try again.": "Kunde inte spela upp ljud automatiskt. Klicka på spela för att försöka igen.",
  "Failed to load audio. Please try again.": "Kunde inte ladda ljud. Försök igen.",
  "Audio playback was aborted.": "Ljuduppspelningen avbröts.",
  "Network error occurred while loading audio.": "Nätverksfel uppstod vid laddning av ljud.",
  "Audio decoding failed.": "Ljudavkodning misslyckades.",
  "Audio format not supported.": "Ljudformatet stöds inte.",
  "Failed to setup audio playback": "Kunde inte konfigurera ljuduppspelning",
  "Failed to generate speech": "Kunde inte generera tal",
  "Failed to generate audio. Please try again.": "Kunde inte generera ljud. Försök igen.",
  "Failed to play audio. Please try again.": "Kunde inte spela upp ljud. Försök igen.",
  
  // Update Notifications
  "update.updateAvailable": "Uppdatering tillgänglig",
  "update.newVersionAvailable": "Ny version {{version}} tillgänglig",
  "update.refreshToApply": "Uppdatera för att tillämpa de senaste funktionerna och förbättringarna",
  "update.later": "Senare",
  "update.updateNow": "Uppdatera nu",
  
  // CSAT Feedback
  "We Value Your Feedback": "Vi värdesätter din feedback",
  "Give Feedback": "Ge feedback",
  "How would you rate your experience?": "Hur skulle du betygsätta din upplevelse?",
  "Very Dissatisfied": "Mycket missnöjd",
  "Dissatisfied": "Missnöjd",
  "Neutral": "Neutral",
  "Satisfied": "Nöjd",
  "Very Satisfied": "Mycket nöjd",
  "Select a rating": "Välj ett betyg",
  "Comments or Bug Report": "Kommentarer eller felrapport",
  "Please share your thoughts or report any issues...": "Vänligen dela dina tankar eller rapportera eventuella problem...",
  "Contact Number": "Kontaktnummer",
  "Feedback Type": "Typ av feedback",
  "Select a feedback type": "Välj en feedbacktyp",
  "Loading...": "Laddar...",
  "No feedback types available": "Inga feedbacktyper tillgängliga", 
  "(Optional)": "(Valfritt)",
  "Feedback Submitted": "Feedback skickad",
  "Thank you for your feedback!": "Tack för din feedback!",
  "Rating Required": "Betyg krävs",
  "Please select a rating before submitting.": "Vänligen välj ett betyg innan du skickar in.",
  "Submit Feedback": "Skicka feedback",
  "Submitting...": "Skickar...",
  "General": "Allmänt",
  "Bug": "Fel",
  "Idea": "Idé",
  
  // Feedback Dashboard
  "Feedback Dashboard": "Feedbackpanel",
  "Total Feedbacks": "Totalt antal feedback",
  "All-time submissions": "Alla inlämningar",
  "Average Rating": "Genomsnittligt betyg",
  "Out of 5 stars": "Av 5 stjärnor",
  "Feedback with Comments": "Feedback med kommentarer",
  "Detailed feedback": "Detaljerad feedback",
  "Rating Distribution": "Betygsfördelning",
  "Breakdown of user satisfaction": "Fördelning av användarnöjdhet",
  "Rating Percentage": "Betygsprocent",
  "Proportion of each rating": "Andel av varje betyg",
  "Responses": "Svar",
  "All Feedback": "All feedback",
  "Detailed view of user submissions": "Detaljerad vy av användarinlämningar",
  "ID": "ID",
  "Rating": "Betyg",
  "Comment": "Kommentar",
  "Contact": "Kontakt",
  "Date": "Datum",
  "Page": "Sida",
  "No feedback data available": "Ingen feedbackdata tillgänglig",
  "No comment": "Ingen kommentar",
  "Not provided": "Ej angivet",
  "Not available": "Ej tillgängligt",
  
  // Authentication
  "Login": "Logga in",
  "Register": "Registrera",
  "Username": "Användarnamn",
  "Password": "Lösenord",
  "Confirm Password": "Bekräfta lösenord",
  "Email": "E-post",
  "Full Name": "Fullständigt namn",
  "Don't have an account?": "Har du inget konto?",
  "Already have an account?": "Har du redan ett konto?",
  "Login to continue": "Logga in för att fortsätta",
  "Create an account": "Skapa ett konto",
  "Passwords must match": "Lösenorden måste matcha",
  "Invalid email": "Ogiltig e-postadress",
  "Required": "Obligatoriskt",
  "Unauthorized": "Obehörig",
  "You don't have permission to access this page.": "Du har inte behörighet att komma åt denna sida."
};